export const mockOnboardingData = [
  {
    uuid: "ob-001",
    employee_uuid: "emp-016",
    stage: "Offer Accepted",
    start_date: "2026-06-10"
  },
  {
    uuid: "ob-002",
    employee_uuid: "emp-017",
    stage: "Offer Accepted",
    start_date: "2026-06-15"
  },
  {
    uuid: "ob-003",
    employee_uuid: "emp-018",
    stage: "Offer Accepted",
    start_date: "2026-06-20"
  },
  {
    uuid: "ob-004",
    employee_uuid: "emp-019",
    stage: "Documents Submitted",
    start_date: "2026-06-25"
  },
  {
    uuid: "ob-005",
    employee_uuid: "emp-020",
    stage: "Documents Submitted",
    start_date: "2026-07-01"
  },
  {
    uuid: "ob-006",
    employee_uuid: "emp-021",
    stage: "Documents Submitted",
    start_date: "2026-07-05"
  },
  {
    uuid: "ob-007",
    employee_uuid: "emp-022",
    stage: "Background Verification",
    start_date: "2026-07-10"
  },
  {
    uuid: "ob-008",
    employee_uuid: "emp-023",
    stage: "Background Verification",
    start_date: "2026-07-15"
  },
  {
    uuid: "ob-009",
    employee_uuid: "emp-024",
    stage: "Background Verification",
    start_date: "2026-07-20"
  },
  {
    uuid: "ob-010",
    employee_uuid: "emp-025",
    stage: "Assets Assigned",
    start_date: "2026-07-25"
  },
  {
    uuid: "ob-011",
    employee_uuid: "emp-026",
    stage: "Assets Assigned",
    start_date: "2026-08-01"
  },
  {
    uuid: "ob-012",
    employee_uuid: "emp-027",
    stage: "Orientation",
    start_date: "2026-08-02"
  },
  {
    uuid: "ob-013",
    employee_uuid: "emp-028",
    stage: "Orientation",
    start_date: "2026-08-03"
  },
  {
    uuid: "ob-014",
    employee_uuid: "emp-029",
    stage: "Completed",
    start_date: "2026-08-04"
  },
  {
    uuid: "ob-015",
    employee_uuid: "emp-030",
    stage: "Completed",
    start_date: "2026-08-05"
  }
];